var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05227 8.26275C6.11833 7.93417 6.25352 7.62341 6.44887 7.35108C6.64421 7.07875 6.89524 6.85108 7.1853 6.68319C7.47536 6.51529 7.79781 6.411 8.13125 6.37725C8.4647 6.3435 8.8015 6.38105 9.11932 6.48741C9.43714 6.59378 9.72871 6.76652 9.97467 6.99418C10.2206 7.22184 10.4153 7.4992 10.5459 7.80787C10.6765 8.11654 10.7399 8.44945 10.732 8.7845C10.7241 9.11955 10.645 9.44909 10.4999 9.75123C10.1556 10.8368 8.70239 11.607 8.45122 12.9445C8.20006 14.2819 5.72401 14.3507 5.87157 12.4422",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60701 8.68313C9.60701 8.68313 9.78561 7.42383 8.62503 7.42383C7.46445 7.42383 7.65806 9.47429 6.57422 9.47429",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48855 4.66211C9.50643 4.66211 10.4826 5.06646 11.2024 5.78621C11.9221 6.50595 12.3265 7.48214 12.3265 8.50002M7.05134 10.8041C7.05134 10.8041 6.64844 10.869 6.64844 11.5021C6.64844 12.1352 8.011 12.0777 8.011 11.0989C8.011 10.12 6.90658 9.62083 7.48983 8.62839L7.05134 10.8041Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 2.7793C9.23552 2.7793 9.97931 2.92725 10.6733 3.2147C11.3672 3.50215 11.9978 3.92347 12.5289 4.45461C13.0601 4.98575 13.4814 5.61631 13.7689 6.31028C14.0563 7.00424 14.2043 7.74803 14.2043 8.49918",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewListen);
export default __webpack_public_path__ + "static/media/new-listen.c21f3509204422eef1edc0f224cd9914.svg";
export { ForwardRef as ReactComponent };